/**
 * Friend vs enemy stroke colors — must stay divergent on a dark stage.
 * Pastel cyan + pink (old) sit at similar lightness and read as one “soft glow”.
 * Blue ↔ amber is a high-separation pair (hue + warmth; better for many CV types).
 */

/** Friend / attraction — blue-500 */
export const RELATION_FRIEND_RGB = [59, 130, 246] as const;

/** Enemy / repulsion — amber-500 (warm, not adjacent to blue) */
export const RELATION_ENEMY_RGB = [245, 158, 11] as const;

/** Selected particle halo — neutral white so it isn’t a third “relation” color */
export const RELATION_SELECT_RGB = [248, 250, 252] as const;

export function rgba(
  rgb: readonly [number, number, number],
  alpha: number,
): string {
  const a = Math.max(0, Math.min(1, alpha));
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${a})`;
}
